var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Picture } from '../../picture';
import { PanelMediaImage, PanelMediaVideo } from '../components/PanelMedia/styles';
export const selectCorrectMedia = ({ image, videoId }) => {
    if (videoId) {
        return _jsx(PanelMediaVideo, { id: videoId });
    }
    if (image) {
        const { alt, sources } = image, imageProps = __rest(image, ["alt", "sources"]);
        return (_jsxs(Picture, { children: [sources && _jsx(Picture.Sources, { sources: sources }), _jsx(PanelMediaImage, Object.assign({}, imageProps, { alt: alt !== null && alt !== void 0 ? alt : '' }))] }));
    }
    return null;
};
